import {
  DEFAULT_LANGUAGE,
  LANGUAGE_QUERY_PARAM,
  SUPPORTED_LANGUAGES,
  type SupportedLanguageCode,
} from '../i18n/languages';
import { absoluteUrl } from './site';

export const normalizeLanguageCode = (language?: string | null): SupportedLanguageCode => {
  const base = language?.split('-')[0] ?? DEFAULT_LANGUAGE;
  return (
    SUPPORTED_LANGUAGES.find((entry) => entry.code === base)?.code ?? DEFAULT_LANGUAGE
  );
};

/** Build an absolute URL for a path and language (always includes ?lang=). */
export const localizedUrl = (path: string, language: SupportedLanguageCode): string => {
  const url = new URL(absoluteUrl(path));
  url.searchParams.set(LANGUAGE_QUERY_PARAM, language);

  const query = url.searchParams.toString();
  return `${url.origin}${url.pathname}?${query}`;
};

export const localizedAlternates = (path: string) =>
  SUPPORTED_LANGUAGES.map((language) => ({
    code: language.code,
    hreflang: language.hreflang,
    href: localizedUrl(path, language.code),
  }));
